import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, BrowserBackGuard } from 'cbc-shared-lib';
import { Sgkc031dComponent } from './pages/sgkc031d/pages/sgkc031d/sgkc031d.component';
import { Sgkc021dComponent } from './pages/sgkc021d/pages/sgkc021d/sgkc021d.component';
import { Sgkc012dComponent } from './pages/sgkc012d/pages/sgkc012d/sgkc012d.component';
import { Sgkc032dComponent } from './pages/sgkc032d/pages/sgkc032d/sgkc032d.component';
import { Sgkc034dComponent } from './pages/sgkc034d/pages/sgkc034d/sgkc034d.component';
import { Sgkc041dComponent } from './pages/sgkc041d/pages/sgkc041d/sgkc041d.component';

const routes: Routes = [
    {
        path: '',
        canActivate: [AuthGuard],
        canDeactivate: [BrowserBackGuard],
        children: [
            { path: 'sgkc021d', component: Sgkc021dComponent, canDeactivate: [BrowserBackGuard] },
            { path: 'sgkc012d', component: Sgkc012dComponent, canDeactivate: [BrowserBackGuard] },
            { path: 'sgkc031d', component: Sgkc031dComponent, canDeactivate: [BrowserBackGuard] },
            { path: 'sgkc032d', component: Sgkc032dComponent, canDeactivate: [BrowserBackGuard] },
            { path: 'sgkc034d', component: Sgkc034dComponent, canDeactivate: [BrowserBackGuard] },
            { path: 'sgkc041d', component: Sgkc041dComponent, canDeactivate: [BrowserBackGuard] },
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SgKcMainRoutingModule { }
